'use client';

import { Button, Stack } from '@mui/material';
import { useTranslations } from 'next-intl';

import BlogCard from '@/components/BlogCard';
import HorizontalSlider from '@/components/HorizontalSlider';
import SliderSection from '@/components/SliderSection';
import { Link } from '@/i18n/navigation';
import { BlogPost } from '@/types/blog.type';

import styles from './ReadMoreBlogsSection.module.scss';

interface ReadMoreBlogsSectionProps {
  posts: BlogPost[];
}

const ReadMoreBlogsSection = ({ posts }: ReadMoreBlogsSectionProps) => {
  const t = useTranslations('common');

  if (posts.length === 0) {
    return null;
  }

  return (
    <>
      <SliderSection title={t('blog.readMore')} customStyles={{ container: styles.container }}>
        {handleSwiper => (
          <HorizontalSlider
            data={posts}
            handleSwiper={handleSwiper}
            customStyles={{ slide: styles.slide }}
            renderItem={(post: BlogPost) => (
              <BlogCard
                slug={post.slug}
                image={post.cardImage}
                imageAlt={post.title}
                date={post.date}
                readTime={post.readTime}
                title={post.title}
                author={post.author}
              />
            )}
          />
        )}
      </SliderSection>
      <Stack alignItems="center" mb={{ xs: 23, md: 31 }}>
        <Link href="/blog">
          <Button size="large">{t('blog.readOurBlogs')}</Button>
        </Link>
      </Stack>
    </>
  );
};

export default ReadMoreBlogsSection;
